import React from 'react';

import { DashboardWidgetProps } from './DashboardWidgetProps';

const SimpleTableWidget: React.FC<DashboardWidgetProps> = (props: DashboardWidgetProps) => {
  return <></>;
};

export default SimpleTableWidget;
